import { render, staticRenderFns } from "./InvitationLayout.vue?vue&type=template&id=0ab2eeca&scoped=true&"
import script from "./InvitationLayout.vue?vue&type=script&lang=js&"
export * from "./InvitationLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab2eeca",
  null
  
)

export default component.exports